export const mintAddress = '9sbrLLnk4vxJajnZWXP9h5qk1NDFw7dz2eHjgemcpump';
export const solanaNetwork = 'mainnet-beta';
export const solanaRpcUrl = 'https://mainnet.helius-rpc.com/?api-key=287aeca9-9bb7-46a0-ac2e-b9ec955c5adc';
export const dAppAuthCookieName = 'dappslap_dapp_jwt';
export const apiUrl = 'https://prod.api.dappslap.ai';
export const dappId = '67915f44902355b186c4bbf7';
